export const style = {
  link: {
    color: `#A94545`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/Privacy/style/links.js